import { api, unwrap, type APIResponse, type Paginated } from "./client";

export interface Country {
  country_id: number;
  name: string;
  iso_code_2: string | null;
  iso_code_3: string | null;
  dialing_code: string | null;
  region_id: string | null;
}

export interface Region {
  region_id: string;
  name: string;
}

export interface AreaCodeGroup {
  group_id: number;
  name: string;
  area_codes: string;
  description: string | null;
}

export async function listCountries(page = 1, per_page = 100): Promise<Paginated<Country>> {
  const resp = await api.get<Paginated<Country>>("/geography/countries", {
    params: { page, per_page },
  });
  if (!resp.data.success) throw new Error(resp.data.error || "Failed to load countries");
  return resp.data;
}

export async function listRegions(): Promise<Region[]> {
  const resp = await api.get<APIResponse<Region[]>>("/geography/regions");
  return unwrap(resp.data);
}

export async function listAreaCodeGroups(): Promise<AreaCodeGroup[]> {
  const resp = await api.get<APIResponse<AreaCodeGroup[]>>("/geography/area-code-groups");
  return unwrap(resp.data);
}
